import { render, staticRenderFns } from "./BankWarn.vue?vue&type=template&id=1600a02c&scoped=true&"
import script from "./BankWarn.vue?vue&type=script&lang=js&"
export * from "./BankWarn.vue?vue&type=script&lang=js&"
import style0 from "./BankWarn.vue?vue&type=style&index=0&id=1600a02c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1600a02c",
  null
  
)

export default component.exports